module.exports = __webpack_public_path__ + "img/eesl-logo.7445c6fe.png";